import './rating-with-logo-hero.scss';
